export type CategoryName = 'General' | 'Serving' | 'Cleaning' | 'Cooking';

export const CATEGORY_ORDER: CategoryName[] = [
  'General',
  'Serving',
  'Cleaning',
  'Cooking',
];

export const CATEGORY_META: Record<
  CategoryName,
  { bg: string; svgBody: string }
> = {
  General: {
    bg: '#4AC5A2',
    svgBody:
      '<ellipse cx="27" cy="18" rx="12" ry="12" fill="rgba(255,255,255,0.35)"/>' +
      '<path d="M8 52c0-10.5 8.5-19 19-19s19 8.5 19 19" fill="rgba(255,255,255,0.35)"/>',
  },
  Serving: {
    bg: '#E36656',
    svgBody:
      '<circle cx="27" cy="14" r="9" fill="rgba(255,255,255,0.35)"/>' +
      '<path d="M12 28 Q14 22 27 22 Q40 22 42 28 L44 44 Q27 48 10 44Z" fill="rgba(255,255,255,0.35)"/>' +
      '<rect x="23" y="44" width="8" height="6" rx="2" fill="rgba(255,255,255,0.25)"/>',
  },
  Cleaning: {
    bg: '#EEAE54',
    svgBody:
      '<rect x="21" y="5" width="6" height="28" rx="3" fill="rgba(255,255,255,0.35)"/>' +
      '<ellipse cx="24" cy="36" rx="13" ry="7" fill="rgba(255,255,255,0.35)"/>' +
      '<rect x="16" y="40" width="16" height="8" rx="3" fill="rgba(255,255,255,0.25)"/>',
  },
  Cooking: {
    bg: '#64798A',
    svgBody:
      '<ellipse cx="27" cy="16" rx="14" ry="12" fill="rgba(255,255,255,0.35)"/>' +
      '<rect x="13" y="26" width="28" height="4" rx="2" fill="rgba(255,255,255,0.35)"/>' +
      '<rect x="17" y="30" width="20" height="14" rx="2" fill="rgba(255,255,255,0.25)"/>',
  },
};

export const slugifySkillName = (name: string): string =>
  name
    .toLowerCase()
    .replace(/[/\\]/g, '-')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');

const CATEGORY_LOOKUP = new Set<string>(CATEGORY_ORDER);

export const normalizeCategory = (
  raw: string | null | undefined,
): CategoryName => {
  if (!raw) return 'General';
  const trimmed = raw.trim();
  if (CATEGORY_LOOKUP.has(trimmed as CategoryName))
    return trimmed as CategoryName;
  return 'General';
};
